import { client } from "../../../App";
import React, { Suspense, useEffect, useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { UserRoleEnum } from "../../../helpers/enums";
import {
  formatContractStatus,
  handlerErrors,
  isObject,
  SwitchUser,
} from "../../../helpers/helpers";
import {
  CONTRACTS_ADD_TO_ACCOUNT,
  getEvictionForMutation,
} from "../../../helpers/mutations";
import { GET_CONTRACT_FISCAL_CODE } from "../../../helpers/queries";
import { hideLoading, showLoading } from "../../../reducers/app";
import { setSkipSpidAction } from "../../../reducers/auth";
import {
  setContractsSelected,
  setReloadContracts,
} from "../../../reducers/contracts";
import DataTable from "../../common/DataTable/DataTable";
import Hero from "../../common/Hero/Hero";
import Modal from "../../common/Modal/Modal";
import AssociateContractsAddForm from "./AddContractForm/addContract";
import "./AddContractForm/addContract.scss";
import AddToAccount from "./AddToAccount/index";
import "./ContractAddForm.scss";
import { Contracts } from "./model";

const AssociateContractsAddFormTranslated = withTranslation()(
  AssociateContractsAddForm
);

const ContractAddForm = (props) => {
  const dispatch = useDispatch();
  const [contracts, setContracts] = useState([]);
  const [selectedRowsIds, setSelectedRowsIds] = useState({});
  const [genericError, setGenericError] = useState(null);
  const [contractsSpid, setContractsSpid] = useState([]);
  const [spidContractsIsNull, setSpidContractsIsNull] = useState(false);
  const [spidContractsModal, setSpidContractsModal] = useState(false);
  const [flowFinished, setFlowFinished] = useState(false);

  const auth = useSelector((state) => state.auth);
  const userProfile = SwitchUser(auth);
  const role = userProfile ? userProfile.role : null;
  const { t } = useTranslation();
  const history = useHistory();
  const columnsDefinition =
    role !== UserRoleEnum.CONDOMINIUM_ADMIN
      ? [
          {
            Header: t("contract.visualization.contract.code"),
            accessor: "contractIntegraCode",
            id: "contractIntegraCode",
          },
          {
            Header: t("contract.visualization.user.code"),
            accessor: "userCode",
            id: "userCode",
          },
          {
            Header: t("contract.visualization.owner"),
            accessor: "intestatario",
            id: "intestatario",
          },
          {
            Header: t("contract.visualization.point.supply"),
            accessor: "supplyPoint",
            id: "supplyPoint",
          },
          {
            Header: t("contract.visualization.online.bill"),
            accessor: "bolletaStatus",
            id: "bolletaStatus",
          },
          {
            Header: t("contract.visualization.online.bill.email"),
            accessor: "emailBolletaOnline",
            id: "emailBolletaOnline",
          },
          {
            Header: t("contract.visualization.contract.status"),
            accessor: "contractStatus",
            id: "contractStatus",
          },
        ]
      : [
          {
            Header: t("contract.visualization.contract.code"),
            accessor: "contractIntegraCode",
            id: "contractIntegraCode",
          },
          {
            Header: t("contract.visualization.user.code"),
            accessor: "userCode",
            id: "userCode",
          },
          {
            Header: t("contract.visualization.owner"),
            accessor: "intestatario",
            id: "intestatario",
          },
          {
            Header: t("contract.visualization.point.supply"),
            accessor: "supplyPoint",
            id: "supplyPoint",
          },
          {
            Header: t("contract.visualization.contract.status"),
            accessor: "contractStatus",
            id: "contractStatus",
          },
        ];
  let contractSpidArray = [];
  let { spidPage } = props;

  useEffect(() => {
    if (auth.auth_issuer === "SPID" && spidPage) {
      dispatch(setSkipSpidAction(true));
      dispatch(showLoading());
      const foundContracts = async () =>
        client().query({
          query: GET_CONTRACT_FISCAL_CODE,
          variables: { fiscalNumber: auth.profile.fiscalCode },
        });
      foundContracts()
        .then(({ data }) => {
          dispatch(hideLoading());
          const foundContractsList = data.searchContractList.contracts;
          console.log(foundContractsList);
          if (foundContractsList.length === 0) {
            setSpidContractsIsNull(true);
            setSpidContractsModal(true);
          }
          foundContractsList.forEach((contract) => {
            const f = contractsSpid.find((c) => {
              return c.contractId === contract.contractId;
            });
            if (!f) {
              const {
                puf,
                contractId,
                serviceOnlineBill,
                integraContractCode,
                status,
                integraClientCode,
                accountHolder,
                token,
              } = contract;
              contractSpidArray.push({
                contractId: contractId,
                contractIntegraCode: integraContractCode,
                userCode: integraClientCode,
                supplyPoint: `${puf.street}, ${puf.streetNumber}`,
                intestatario: accountHolder.businessName,
                emailBolletaOnline: serviceOnlineBill.email || "-",
                contractStatus: formatContractStatus(status.code).props.i18nKey,
                bolletaStatus: serviceOnlineBill.enabled
                  ? "online.bills.table.active"
                  : "online.bills.table.deactive",
                token,
              });
            }
          });
          setContractsSpid(contractSpidArray);
        })
        .catch((error) => {
          dispatch(hideLoading());
          setSpidContractsIsNull(true);
          setSpidContractsModal(true);
        });
    }
  }, []);
  const textHero =
    spidPage && !spidContractsIsNull && auth.auth_issuer === "SPID"
      ? t("associate-contact.descriptionSecondScreenSpid")
      : t("associate-contact.descriptionSecondScreen");
  const contractsDataTable =
    auth.auth_issuer === "SPID" && !spidContractsIsNull && spidPage
      ? contractsSpid
      : contracts;
  const columns = React.useMemo(() => {
    let specialColumns = [
      {
        Header: ({ getToggleAllRowsSelectedProps }) => {
          const p = getToggleAllRowsSelectedProps();
          delete p.indeterminate;
          delete p.title;
          const isChecked = p.checked;
          return (
            <label className="container-checkbox">
              <input
                {...p}
                type="checkbox"
                name="selectAll"
                id="checkbox-all"
                aria-label={t("header.checkbox.all.label")}
              />
              <span
                className={`checkmark color-sky ${
                  isChecked ? "checked-input" : ""
                }`}
              ></span>
            </label>
          );
        },

        id: "expander",
        meta: { omitThAria: true },
        accessor: "expander",
        Cell: ({ row }) => {
          const p = row.getToggleRowSelectedProps();
          delete p.indeterminate;
          delete p.title;
          const isChecked = p.checked;
          return (
            <label className="container-checkbox">
              <input
                {...p}
                type="checkbox"
                name="selectRow"
                id={`checkbox-${row.id}`}
                aria-label={
                  t("select.contract.table") +
                  " " +
                  row.original.contractIntegraCode
                }
              />
              <span
                className={`checkmark ${isChecked ? "checked-input" : ""}`}
              ></span>
            </label>
          );
        },
      },
      ...columnsDefinition.map((column) => {
        return {
          Header: column.Header,
          id: column.id,
          accessor: column.accessor,
          Cell: ({ row }) => {
            const title = getColumnValue(column, row);
            return (
              <span>
                <p title={title}> {title} </p>
              </span>
            );
          },
        };
      }),
    ];

    const getColumnValue = (column, row) => {
      if (
        column.accessor === "contractStatus" ||
        column.accessor === "bolletaStatus"
      )
        return t(row.original[column.accessor]);
      return row.original[column.accessor];
    };
    return specialColumns;
  }, [role, columnsDefinition, t, dispatch]);

  const handleContactSubmitAdmin = () => {
    let dataToBeSubmited = [];
    Object.keys(selectedRowsIds).forEach((index) => {
      const targetContractId = contracts[Number(index)].contractId;
      const dataBasedOnRole = contracts.map(
        ({
          contractId,
          intestatario,
          userCode,
          supplyPoint,
          contractIntegraCode,
          token,
        }) => {
          return {
            contractId,
            intestatario,
            userCode,
            supplyPoint,
            integraContractCode: contractIntegraCode,
            token,
          };
        }
      );
      const targetContracts = dataBasedOnRole.filter(
        (contract) => contract.contractId === targetContractId
      );
      dataToBeSubmited.push(...targetContracts);
    });
    dispatch(setContractsSelected(dataToBeSubmited));
    history.push("/contracts/add/condominium-admin");
  };

  const handleContactSubmit = () => {
    setGenericError(null);
    let dataToBeSubmited = [];
    if (spidPage && contractsSpid.length > 0) {
      Object.keys(selectedRowsIds).forEach((index) => {
        const targetContractId = contractsSpid[Number(index)].contractId;
        console.log(targetContractId, ": targget contractId");
        const dataBasedOnRole = contractsSpid.map(
          ({ contractId, token, contractIntegraCode }) => {
            return {
              integraContractCode: contractIntegraCode,
              contractId,
              token,
            };
          }
        );
        const targetContracts = dataBasedOnRole.filter(
          (contract) => contract.contractId === targetContractId
        );
        dataToBeSubmited.push(...targetContracts);
      });
    } else {
      Object.keys(selectedRowsIds).forEach((index) => {
        const targetContractId = contracts[Number(index)].contractId;
        const dataBasedOnRole = contracts.map(
          ({ contractId, token, contractIntegraCode }) => {
            return {
              integraContractCode: contractIntegraCode,
              contractId,
              token,
            };
          }
        );
        const targetContracts = dataBasedOnRole.filter(
          (contract) => contract.contractId === targetContractId
        );
        dataToBeSubmited.push(...targetContracts);
      });
    }
    setGenericError(null);
    const formatedData = Contracts.makeData(dataToBeSubmited);
    dispatch(showLoading());
    client()
      .mutate({
        mutation: CONTRACTS_ADD_TO_ACCOUNT,
        variables: { contracts: formatedData },
        update: (cache) => {
          const fieldsToEvict = getEvictionForMutation("associateContract");
          fieldsToEvict.forEach((field) => cache.evict({ fieldName: field }));
          cache.gc();
        },
      })
      .then((result) => {
        dispatch(setReloadContracts(true));
        dispatch(hideLoading());
        setFlowFinished(true);
      })
      .catch((error) => {
        handlerErrors(error, setGenericError, setGenericError);
        dispatch(hideLoading());
      });
  };

  const handleFormErrors = (e) => {
    if (e === null) {
      setGenericError(null);
      return;
    }
    handlerErrors(e, setGenericError, setGenericError);
  };

  const handleGenericError = () => {
    let error = isObject(genericError)
      ? genericError[Object.keys(genericError)[0]]
      : genericError;
    let formatedError = error.includes("_")
      ? t(`associate-contact.${error}`)
      : error.includes(":")
      ? t(`${error}`, { nsSeparator: "|" })
      : t(`${error}`);
    return (
      <div className={"row container"}>
        <div className="col-sm-12 p-0">
          <div className={"generic-error d-flex justify-content-start"}>
            <i
              className="gc-icon-functional-attention-1-col"
              aria-hidden="true"
            />
            <p>{formatedError}</p>
          </div>
        </div>
      </div>
    );
  };
  const blockWithPopUp =
    userProfile &&
    userProfile.isCondominiumAdminDisabled &&
    role === UserRoleEnum.CONDOMINIUM_ADMIN;
  return (
    <div className="ContractAddForm" data-testid="ContractAddForm">
      <Hero
        backTo={"/dashboard"}
        backToText={t("common.back.home")}
        title={t("associate-contact.titleSecondScreen")}
        short={false}
        autoOpen={blockWithPopUp}
        block={blockWithPopUp}
        blockText={t("associate-contract.block-view")}
        blockButton={t("common.hoCapito")}
        description={textHero}
      />
      <div className="associate-contract-add container   ">
        <div className="mt-5 text-center">
          {auth.auth_issuer !== "SPID" || spidContractsIsNull || !spidPage ? (
            <Suspense fallback="loading">
              <AssociateContractsAddFormTranslated
                sendError={handleFormErrors}
                setGenericError={setGenericError}
                sendData={(foundContracts) => {
                  foundContracts.forEach((contract) => {
                    const f = contracts.find((c) => {
                      return c.contractId === contract.contractId;
                    });

                    if (!f) {
                      const {
                        puf,
                        contractId,
                        serviceOnlineBill,
                        integraContractCode,
                        status,
                        integraClientCode,
                        accountHolder,
                        token,
                      } = contract;
                      setContracts([
                        ...contracts,
                        {
                          contractId: contractId,
                          contractIntegraCode: integraContractCode,
                          userCode: integraClientCode,
                          supplyPoint: `${puf.street}, ${puf.streetNumber}`,
                          intestatario: accountHolder.businessName,
                          emailBolletaOnline: serviceOnlineBill.email || "-",
                          contractStatus: formatContractStatus(status.code)
                            .props.i18nKey,
                          bolletaStatus: serviceOnlineBill.enabled
                            ? "online.bills.table.active"
                            : "online.bills.table.deactive",
                          token,
                        },
                      ]);
                    }
                  });
                }}
              />
            </Suspense>
          ) : (
            <>
              <div className="AddContractForm addSpid mt-5 container">
                <div className="row">
                  <div className="col-xs-12 col-md-12 text-left">
                    <div className={"row"}>
                      <div className="form-info col-sm-12">
                        <h2 className="headline-bold-fs5">
                          {t("common.addContracts")}
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          <Modal
            show={flowFinished}
            icon={"gc-icon-functional-check-2-col"}
            onClose={() => setFlowFinished(false)}
            descriptionClass={"paragraph-main-fs8"}
            content={
              <div>
                <p>{t("associate-contact.successAddContracts")}</p>
                <p>
                  {spidPage && !spidContractsIsNull
                    ? ""
                    : t("associate-contact.modalBodyNote")}
                </p>
              </div>
            }
            type={"link"}
            styleType={"primary"}
            to={"/"}
            linkTitle={t("common.goToDashboard")}
          />

          <Modal
            show={spidContractsModal}
            onClose={() => setSpidContractsModal(false)}
            description={t("dashboard.associateContract.title")}
            type={"button"}
            onFirstClick={() => setSpidContractsModal(false)}
            linkTitle={t("common.contractAssociateLink")}
          />

          {contractsDataTable.length > 0 ? (
            <DataTable
              excludeKeys={["contractId"]}
              columns={columns}
              data={contractsDataTable}
              selectedRowsIds={(e) => setSelectedRowsIds(e)}
            />
          ) : null}

          {genericError && handleGenericError()}
          {(contracts.length > 0 || contractsSpid.length > 0) &&
          Object.keys(selectedRowsIds).length ? (
            <AddToAccount
              selectedRowsIds={selectedRowsIds}
              onSubmit={() => {
                role === UserRoleEnum.CONDOMINIUM_ADMIN
                  ? handleContactSubmitAdmin()
                  : handleContactSubmit();
              }}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

ContractAddForm.propTypes = {};

export default ContractAddForm;
